/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

/**
 * Shared TanStack Query key constants.
 * Use these for cache invalidation so all consumers stay in sync.
 */

export const BRANDING_QUERY_KEY = ["admin", "settings", "branding"] as const;
